export enum UcaStatus {
    SUCCESS = "APPLY_COMPLETED",
    FAILURE = "APPLY_FAILED",
    IN_PROCESS = "APPLY_IN_PROCESS"
}

export enum ExternalStatus {
    SUCCESS = "COMPLETED",
    FAILURE = "FAILED",
    IN_PROCESS = "IN_PROCESS"
}

export enum DisplayStatus {
    SUCCESS = "Completed",
    FAILURE = "Failed",
    IN_PROCESS = "In Process",
}

export const ICON_PATHS: Record<DisplayStatus, string> = {
    [DisplayStatus.SUCCESS]: "/assets/cloud-automation-designer/icons/success.svg",
    [DisplayStatus.FAILURE]: "/assets/cloud-automation-designer/icons/failed.svg",
    [DisplayStatus.IN_PROCESS]: "/assets/cloud-automation-designer/icons/progress.svg"
};

export const STATUS_ICON_TOOL_TIP: Record<DisplayStatus, string> = {
    [DisplayStatus.SUCCESS]: "Request completed",
    [DisplayStatus.FAILURE]: "Request failed. Click first, then check Request Summary on the right for details. ",
    [DisplayStatus.IN_PROCESS]: "Request in process"
};

export const NAVIGATE_OUT_OF_CAD_DESIGNER_CONFIRMATION_MESSAGE = 'You are about to leave Cloud Automation Designer. \nAny unsaved changes will be lost. \n Choose Stay to continue editing, or Leave to exit without saving.';